import React, { useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";

import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import RefreshIcon from "@mui/icons-material/Refresh";

import PageContainer from "components/templates/PageContainer";
import InfoTooltip from "components/atoms/info/InfoTooltip";
import SelectBlock from "components/atoms/select/SelectBlock";
import SelectUnit from "components/atoms/select/SelectUnit";
import ButtonDatePicker from "components/atoms/dateTime/ButtonDatePicker";
import { getFormattedDateURL } from "components/atoms/dateTime/GetFormattedDate";
import { SnackContext } from "context/SnackProvider";
import instance, { getErrorMessage } from "api/definitions";
import ReportLocationDensityTable from "components/molecules/table/ReportLocationDensityTable";

const GetLocationDensity = (props) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);

  const snackContext = useContext(SnackContext);

  useEffect(() => {
    setIsLoaded(false);
    const idUnit = props.idUnit ? "&idUnidade=" + props.idUnit : "";
    const idBlock = props.idBlock ? "&idBloco=" + props.idBlock : "";
    const idActivityType = "&idAtividadeTipo=2";
    const fullURL = `relatorio/deptoLocalDensidade?date=${props.reportDate}${idBlock}${idUnit}${idActivityType}`;
    instance
      .get(fullURL)
      .then(function (response) {
        setIsLoaded(true);
        const result = response.data;
        setItems(result);
      })
      .catch(function (error) {
        setIsLoaded(true);
        const msg = getErrorMessage(error);
        snackContext.setMessage(msg, "error");
      });
  }, [props.reportDate, props.idBlock, props.idUnit, snackContext]);

  if (!isLoaded) {
    return <CircularProgress />;
  } else {
    return <ReportLocationDensityTable rows={items} />;
  }
};

const ReportLocationDensity = () => {
  const [unit, setUnit] = useState(null);
  const [block, setBlock] = useState(null);
  const [dateReservation, setDateReservation] = useState(new Date());

  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const blockCallback = (childData) => {
    setBlock(childData);
  };

  const unitCallback = (childData) => {
    setUnit(childData);
  };

  const handleChangeDateReservation = (newValue) => {
    setDateReservation(newValue);
  };

  const handleClean = (event) => {
    blockCallback(null);
    unitCallback(null);
    setDateReservation(new Date());
  };

  return (
    <PageContainer
      maxWidth="lg"
      title={"Locais ocupados por Departamento"}
      icon={<AccountBalanceIcon />}
    >
      <Box id="ControlButtons" sx={{ mt: 2 }}>
        <InfoTooltip placement="top-start" title="Voltar">
          <IconButton onClick={handleBack}>
            <ArrowBackIcon />
          </IconButton>
        </InfoTooltip>
        <InfoTooltip title="Reiniciar filtros" placement="top">
          <IconButton variant="contained" onClick={handleClean}>
            <RefreshIcon />
          </IconButton>
        </InfoTooltip>
      </Box>
      <Box>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item xs={4} sm={3} md={2}>
            <ButtonDatePicker
              value={dateReservation}
              onChange={handleChangeDateReservation}
              id="dateReservation"
              label="Data das Reservas"
              name="dateReservation"
              sx={{ mt: 1 }}
            />
          </Grid>
          <Grid item xs={8} sm={5} md={4} lg={3}>
            <SelectUnit
              dataParentToChild={unit}
              parentCallback={unitCallback}
            />
          </Grid>
          <Grid item xs={12} sm={5} md={4} lg={3}>
            <SelectBlock
              dataParentToChild={block}
              parentCallback={blockCallback}
            />
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ mt: 2 }}>
        <GetLocationDensity
          reportDate={getFormattedDateURL(dateReservation)}
          idBlock={block && block.id}
          idUnit={unit && unit.id}
        />
      </Box>
    </PageContainer>
  );
};

export default ReportLocationDensity;
